// Croqui: `components/Eyebrow.tsx`.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';

/** Rótulo em caixa alta. `small` = 10px, tracking menor, sem quebra (mini-KPI). */
export function Eyebrow({
  children,
  small = false,
  className,
}: {
  children: ReactNode;
  small?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'font-semibold uppercase text-faint',
        small ? 'whitespace-nowrap text-10 tracking-[0.04em]' : 'text-11 tracking-[0.08em]',
        className,
      )}
    >
      {children}
    </div>
  );
}
